import React, { useEffect, useRef, useState } from "react";
import siteConfig from "../config/siteConfig";
import productData from "../Datas/productData";
import "../css/contactus.scss";

const initialForm = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

function Contact() {
  const [formData, setFormData] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const submitTimer = useRef(null);

  useEffect(
    () => () => {
      if (submitTimer.current) window.clearTimeout(submitTimer.current);
    },
    []
  );

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
    setShowSuccess(false);
  };

  const validateForm = () => {
    const nextErrors = {};
    if (!formData.firstName.trim())
      nextErrors.firstName = "First name is required.";
    if (!formData.lastName.trim())
      nextErrors.lastName = "Last name is required.";
    if (!/^\S+@\S+\.\S+$/.test(formData.email))
      nextErrors.email = "Enter a valid email address.";
    if (!formData.subject) nextErrors.subject = "Choose a subject.";
    if (formData.message.trim().length < 10)
      nextErrors.message = "Please share at least 10 characters.";
    return nextErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = validateForm();
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    setIsSubmitting(true);
    submitTimer.current = window.setTimeout(() => {
      setFormData(initialForm);
      setIsSubmitting(false);
      setShowSuccess(true);
    }, 650);
  };

  return (
    <main className="contact">
      <section className="contact-intro">
        <div className="contact-image">
          <img
            src={productData[5].image}
            alt={productData[5].name}
            loading="eager"
          />
        </div>
        <div className="contact-copy">
          <p className="eyebrow">Direct support</p>
          <h1>Start a conversation</h1>
          <p>
            Questions about products, delivery or an existing order are handled
            through one direct email address.
          </p>
          <dl>
            <div>
              <dt>Email</dt>
              <dd>
                <a href={`mailto:${siteConfig.contact.email}`}>
                  {siteConfig.contact.email}
                </a>
              </dd>
            </div>
            <div>
              <dt>Company</dt>
              <dd>{siteConfig.legalEntity.name}</dd>
            </div>
            <div>
              <dt>Registered address</dt>
              <dd>{siteConfig.legalEntity.address}</dd>
            </div>
          </dl>
        </div>
      </section>

      <section
        className="contact-form-section"
        aria-labelledby="contact-form-title"
      >
        <div>
          <p className="eyebrow">Send a note</p>
          <h2 id="contact-form-title">How can we help?</h2>
          <p>We aim to respond within one business day.</p>
        </div>
        <form onSubmit={handleSubmit} noValidate>
          <div className="contact-form-grid">
            <label>
              <span>First name *</span>
              <input
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                aria-invalid={Boolean(errors.firstName)}
              />
              {errors.firstName && <small>{errors.firstName}</small>}
            </label>
            <label>
              <span>Last name *</span>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                aria-invalid={Boolean(errors.lastName)}
              />
              {errors.lastName && <small>{errors.lastName}</small>}
            </label>
            <label>
              <span>Email *</span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                aria-invalid={Boolean(errors.email)}
              />
              {errors.email && <small>{errors.email}</small>}
            </label>
            <label>
              <span>Phone (optional)</span>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </label>
            <label className="contact-field-full">
              <span>Subject *</span>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                aria-invalid={Boolean(errors.subject)}
              >
                <option value="">Select a subject</option>
                <option value="order">Order support</option>
                <option value="sizing">Sizing &amp; styling</option>
                <option value="returns">Return or exchange</option>
                <option value="press">Press &amp; partnership</option>
              </select>
              {errors.subject && <small>{errors.subject}</small>}
            </label>
            <label className="contact-field-full">
              <span>Message *</span>
              <textarea
                name="message"
                rows="7"
                value={formData.message}
                onChange={handleInputChange}
                aria-invalid={Boolean(errors.message)}
              />
              {errors.message && <small>{errors.message}</small>}
            </label>
          </div>
          <button
            className="solid-button"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending…" : "Send message"}
          </button>
          {showSuccess && (
            <p className="contact-success" role="status">
              Thank you. Your note has been received.
            </p>
          )}
        </form>
      </section>
    </main>
  );
}

export default Contact;
